/// <amd-module name="VSSUI/SizeObserver" />
export { SizeObserver } from "./Components/SizeObserver/SizeObserver";
export { ISizeObserverProps } from "./Components/SizeObserver/SizeObserver.Props";
